import classNames from 'classnames'
import styles from './styles.module.scss'
import { useEffect, useState } from 'react'
import {  From } from './Form'
import { nanoid } from 'nanoid'
import { useSelector } from 'react-redux'

export const Forms = ({data=[]}) => {
  const [formsData, setFormsData] = useState([])
  const siteInfo = useSelector(state => state?.clientDataReducer?.site_info??null)


  let formsList
  if(formsData?.length) {
    formsList = formsData.map(item => {
      const keyVal = nanoid()
     return  <Form data={item} key={keyVal}/>
    })
  }
  console.log('formsData', formsData)
  useEffect(() => {
    const forms = siteInfo?.forms
    //console.log("1==>:siteInfos", siteInfo  )
    if(forms) {
      const formArr = []
      const arrForms = Object.values(forms)
      if(arrForms?.length) {
        for(let i=0; i<arrForms.length; i++) {
          const form = arrForms[i]
          const formId = Number(form?.id)??null
          if(formsData?.length===0||formsData.find(item => Number(item.id)!==formId)) {
            setFormsData(currentFormList => {
              return [...currentFormList, form]
            })
          }
        }
      }
      
    }
  }, [siteInfo?.forms])

  return (
    <div className={classNames(styles.forms)}>
      {formsList}
    </div>
  )
}
